export default __webpack_public_path__ + "static/media/tappOutcome.c27f74e1.riv";